import { Alert, Button, Tab, Tabs, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router";
import FrittiWikiImageIcon from './assets/Bildmarke.svg';
import FrittiWikiFontIcon from './assets/Wortmake.svg';

const LoginPage = () => {
    
    const typeMap = {
        'LOGIN': {
            'type':'LOGIN',
            'action': '/api/perform_login',
            'label': 'LOGIN'
        },
        'REGISTER': {
            'type':'REGISTER',
            'action':'/api/register',
            'label': 'Registrierung'
        }
    };

    const [searchParams, setSearchParams] = useSearchParams();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [action, setAction] = useState(typeMap['LOGIN']);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [badCredentials, setBadCredentials] = useState(false);

    useEffect(() => {
        setBadCredentials(searchParams?.has('error'));
    }, [searchParams]);

    const handleRegister = async (event) => {
        if(action.action !== '/api/register') return;
        event.preventDefault();
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                'username': email,
                'password': password
            })
        };
        const response = await fetch('api/register', requestOptions);

        if(response.ok){
            setErrorMessage('');
            setSuccessMessage('Erfolgreich registriert');
            changeFormType(null, typeMap.LOGIN.type);
        }else{
            const json = await response.json();
            setErrorMessage(json.message);
        }
    }

    const hasError = () => {
        return (badCredentials || errorMessage !== '');
    }

    const getErrorMessage = () => {
       return (badCredentials ? 'Falscher Username oder Passwort': errorMessage);
    };

    const changeFormType = (event, newValue) =>  {
        setAction(typeMap[newValue]);
        setSearchParams('');
        setErrorMessage('');
        if(newValue == typeMap.REGISTER.type){
            setSuccessMessage('');
        }
    };

    return(
        <div className="centered">
            <img src={FrittiWikiFontIcon} style={{maxWidth: '150px', margin: 'auto', display: 'block', marginTop: '20pt', textAlign: 'center'}} alt="name logo of frittiwiki"/>
            <img src={FrittiWikiImageIcon} style={{maxWidth: '100px', padding: '40px', margin: 'auto', display: 'block'}} alt="logo of frittiwiki"/>
            <Tabs value={action?.type} onChange={changeFormType} aria-label="basic tabs example">
                <Tab label="LOGIN" value={'LOGIN'} />
                <Tab label="REGISTRIERUNG" value={'REGISTER'} />
            </Tabs>
            <form className="centered noMargin" action={action?.action} method="post">
                {successMessage !== '' && <Alert security="info">{successMessage}</Alert>}
                <TextField name="username" label="email" onChange={(event) => setEmail(event.target.value)}></TextField>
                <TextField name="password" label="password" type="password" onChange={(event) => setPassword(event.target.value)}></TextField>
                <Button type="submit" onClick={handleRegister} className={'custom-button-root'}>{action?.label}</Button>
                {hasError() && <Alert severity="error">{getErrorMessage()}</Alert>}
            </form>
        </div>
    );
}

export default LoginPage;
